var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFfvLevel1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "M8.312 2c5.42 7.8-3.898 13-3.898 13h8.73c3.706 0 6.498-2.715 6.498-6.498C19.642 4.715 16.818 2 13.145 2H8.312Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#182865",
  d: "M11.7 6.51c.193-.08.393-.17.6-.27.213-.107.42-.22.62-.34.2-.127.39-.257.57-.39.187-.14.353-.287.5-.44h1.04V12h-1.49V7.01c-.2.133-.423.257-.67.37-.247.107-.487.2-.72.28l-.45-1.15Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ffv-level-1_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ffv-level-1_svg__b)",
  d: "M4.709 8.612C3.81 3.482.083 2 .083 2a16.41 16.41 0 0 1 .742 10.694c1.963-1.33 3.16-2.77 3.884-4.082Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ffv-level-1_svg__c)",
  d: "M5.782 4.238s.26 1.967-1.073 4.374c.179 1.028.247 2.197.146 3.531.44-.422.872-.894 1.252-1.449 2.843-4.14-.325-6.456-.325-6.456Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ffv-level-1_svg__d)",
  d: "M4.855 12.143c-2.113.624-4.034.55-4.034.55A13.694 13.694 0 0 1-.005 15c1.56-.628 3.324-1.385 4.86-2.857Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ffv-level-1_svg__e)",
  d: "M4.855 12.143c.101-1.334.032-2.504-.146-3.53-.725 1.31-1.921 2.75-3.884 4.08 0 0 1.917.074 4.03-.55Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffv-level-1_svg__b",
  x1: 0.815,
  x2: 2.674,
  y1: 2.057,
  y2: 10.21,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#FFD000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.602,
  stopColor: "#FBB900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F39200"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffv-level-1_svg__c",
  x1: 6.814,
  x2: 4.358,
  y1: 5.957,
  y2: 10.324,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF482"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#FFF482"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#FD0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#FFD800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.819,
  stopColor: "#FDC200"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.995,
  stopColor: "#FBB900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBB900"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffv-level-1_svg__d",
  x1: 0.328,
  x2: 4.331,
  y1: 13.984,
  y2: 11.852,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBB900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.435,
  stopColor: "#F9B000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF7D00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffv-level-1_svg__e",
  x1: 0.839,
  x2: 4.971,
  y1: 10.838,
  y2: 10.503,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F39200"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.995,
  stopColor: "#C25F01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C25F01"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ffv-level-1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 2h7.29v13H0z"
})))));
export { SvgFfvLevel1 as ReactComponent };
export default "data:image/svg+xml;base64,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";